const MarqueeItem = () => (
  <div className="flex items-center">
    <span className="text-outline px-10 font-display text-4xl font-extrabold uppercase tracking-tight md:text-6xl">
      Magit S.r.l.
    </span>
    <span className="px-10 font-display text-xl font-semibold uppercase tracking-[0.25em] text-gold md:text-2xl">
      Eccellenza Industriale
    </span>
  </div>
);

const Marquee = () => (
  <section
    data-testid="marquee-ribbon"
    className="border-y border-white/10 bg-ink py-10 md:py-14 overflow-hidden"
  >
    <div className="marquee-track">
      {Array.from({ length: 12 }).map((_, i) => (
        <MarqueeItem key={i} />
      ))}
    </div>
  </section>
);

export default Marquee;
